export interface IProfileRegisterSate {
    profileImage: string;
    email: string;
    carrierYear: number;
}

export interface IProfileRegisterAction {
    type: keyof IProfileRegisterSate | 'SET_STATE';
    value?: IProfileRegisterSate[keyof IProfileRegisterSate] | IProfileRegisterSate;
}

export const defaultState: IProfileRegisterSate = {
    profileImage: '',
    email: '',
    carrierYear: 0,
};

export interface IProfileRegisterReducer {
    (state: IProfileRegisterSate, action: IProfileRegisterAction): IProfileRegisterSate;
}

export default function profileRegisterReducer(state: IProfileRegisterSate, action: IProfileRegisterAction): IProfileRegisterSate {
    const { type, value } = action;
    switch (type) {
        case 'SET_STATE':
            if (typeof value === 'object') {
                state = value || state;

            } else {
                state = defaultState;
            }
            break;
        default: state = { ...state, [type]: value, }
            break;
    }
    return state;
}

